import "./EditAlarmCentralInformation.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditAlarmCentralInformationComponentController from "./EditAlarmCentralInformationComponentController";

export class EditAlarmCentralInformationComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditAlarmCentralInformationComponentController;
        this.templateUrl = "/App/Components/AlarmCentralDialogs/EditAlarmCentralInformation.html";
    }
}

module("mmManagePortal").component("mmEditAlarmCentralInformation", new EditAlarmCentralInformationComponent());
